import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-checked\"><path d=\"M18 1.234L17.54 0C12.062 3.894 8.089 8.793 6.3 11.26L1.936 7.285 0 9.087 7.549 18C8.855 14.143 12.97 6.595 18 1.234z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol